import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Divider, Link, Typography } from '@mui/material';

const Footer = ({ className }) => {
  const currentYear = new Date().getFullYear();
  return (
    <Box sx={{}} className={className}>
      <Divider />
      <Box sx={{ padding: '8px 32px' }}>
        <Typography sx={{}} variant="body1">
          &copy; ProductDock {currentYear}
        </Typography>
        <Typography variant="caption">
          Tech experts in digital transformation. We develop cutting-edge software.
        </Typography>
        <Box sx={{ marginTop: '4px' }}>
          <Link component={RouterLink} to="/privacy-policy" variant="caption">
            Privacy Policy
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

Footer.propTypes = {
  className: PropTypes.string.isRequired,
};

export default Footer;
